import { render } from "./CoursePriceInfoComponent.vue?vue&type=template&id=61d76042&scoped=true"
import script from "./CoursePriceInfoComponent.vue?vue&type=script&lang=js"
export * from "./CoursePriceInfoComponent.vue?vue&type=script&lang=js"

import "./CoursePriceInfoComponent.vue?vue&type=style&index=0&id=61d76042&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d76042"]])

export default __exports__